import { Link } from 'react-router-dom';

const Products = () => {
  const products = [
    {
      id: 1,
      title: 'Extensao Lovable Ilimitado',
      description: 'Use o lovable ilimitado sem gastar seus créditos, com essa extensão',
      image: 'https://static.lumi.new/b6/b647c9c9965f9d2a6e38d7050c764f9c.webp',
      link: '/',
      available: true,
      externalLink: false
    },
    {
      id: 2,
      title: 'Creditos Direto na Sua Conta Lovable',
      description: 'Receba creditos diretamente na sua conta Lovable',
      image: 'https://static.lumi.new/20/2060299bbd3e43532341649d9d9976c5.webp',
      link: '/creditos',
      available: true,
      externalLink: false
    },
    {
      id: 3,
      title: 'Biblia do Lovable',
      description: '101 Hacks e Prompts Que Vao Revolucionar Seus Projetos',
      image: 'https://static.lumi.new/1e/1e7f1d164b44b0a76d3eda0dd183f9dc.webp',
      link: 'https://abibliadolovable.lovable.app/',
      available: true,
      externalLink: true
    },
    {
      id: 4,
      title: 'Vou Migrar Seu Projeto Do Lovable Cloud Para o Supabase',
      description: 'Migracao completa e profissional do seu banco de dados',
      image: 'https://static.lumi.new/11/1147707eed9643322369a4fe31c060f9.webp',
      link: '/migracao',
      available: true,
      externalLink: false
    },
    {
      id: 5,
      title: 'Consultoria Comigo Sobre Seu Projeto Lovable',
      description: 'Vou tirar suas duvidas, te orientar sobre teu projeto, e te mostrar o melhor caminho para evitar erros e dor de cabeca no futuro',
      image: 'https://static.lumi.new/00/008c7e14463c3c9f258d310eb422b345.webp',
      link: '/consultoria',
      available: true,
      externalLink: false
    }
  ];

  const cardStyle = {
    background: '#fff',
    borderRadius: 12,
    border: '1px solid #e5e7eb',
    overflow: 'hidden' as const,
    transition: 'all 0.25s ease',
    cursor: 'pointer',
    height: '100%',
    display: 'flex' as const,
    flexDirection: 'column' as const
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)';
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.borderColor = '#d1d5db';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.boxShadow = 'none';
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.borderColor = '#e5e7eb';
  };

  const renderCard = (product: typeof products[0]) => (
    <div
      style={cardStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Imagem */}
      <div style={{ width: '100%', background: '#000' }}>
        <img
          src={product.image}
          alt={product.title}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </div>

      {/* Conteudo */}
      <div style={{ padding: '16px 20px 20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <h3 style={{
          fontSize: 17,
          fontWeight: 650,
          color: '#111827',
          margin: '0 0 6px',
          lineHeight: 1.3
        }}>
          {product.title}
        </h3>
        <p style={{
          fontSize: 13.5,
          color: '#6b7280',
          margin: '0 0 14px',
          lineHeight: 1.5,
          flex: 1
        }}>
          {product.description}
        </p>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          {product.available ? (
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              fontSize: 12,
              fontWeight: 600,
              color: '#059669',
              background: '#ecfdf5',
              padding: '4px 10px',
              borderRadius: 20
            }}>
              {"\u2713"} Disponivel
            </span>
          ) : (
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              fontSize: 12,
              fontWeight: 600,
              color: '#d97706',
              background: '#fffbeb',
              padding: '4px 10px',
              borderRadius: 20
            }}>
              Em Breve
            </span>
          )}
        </div>

        {/* Botao EU QUERO */}
        <div
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
            color: '#fff',
            fontWeight: 800,
            fontSize: 16,
            textAlign: 'center' as const,
            padding: '14px 20px',
            borderRadius: 10,
            letterSpacing: '0.5px',
            textTransform: 'uppercase' as const,
            boxShadow: '0 4px 14px rgba(22, 163, 74, 0.4)',
            transition: 'all 0.2s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(22, 163, 74, 0.6)';
            e.currentTarget.style.transform = 'scale(1.03)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 14px rgba(22, 163, 74, 0.4)';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {"\uD83D\uDCA5"} EU QUERO!
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Header */}
      <header style={{ padding: 'clamp(32px, 6vw, 48px) 20px clamp(24px, 4vw, 32px)', maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            color: '#6b7280',
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 32,
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#111')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#6b7280')}
        >
          {"\u2190"} Voltar para Home
        </Link>
        <h1 style={{
          fontSize: 'clamp(28px, 6vw, 36px)',
          fontWeight: 700,
          color: '#111827',
          margin: '0 0 8px',
          letterSpacing: '-0.02em'
        }}>
          Nossos Produtos
        </h1>
        <p style={{
          fontSize: 'clamp(14px, 3vw, 16px)',
          color: '#6b7280',
          margin: 0,
          fontWeight: 400
        }}>
          Explore nossa linha completa de solucoes para desenvolvedores
        </p>
      </header>

      {/* Products Grid */}
      <section style={{ padding: '0 20px clamp(48px, 8vw, 64px)', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 24
        }}>
          {products.map((product) => (
            product.externalLink ? (
              <a
                key={product.id}
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {renderCard(product)}
              </a>
            ) : (
              <Link
                key={product.id}
                to={product.link}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {renderCard(product)}
              </Link>
            )
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #f3f4f6',
        padding: '32px 24px',
        textAlign: 'center',
        background: '#fafafa'
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <p style={{ fontSize: 13, color: '#9ca3af', margin: '0 0 8px' }}>
            &copy; 2026 Mestre do Lovable - Todos os direitos reservados
          </p>
          <Link
            to="/privacy"
            style={{ fontSize: 13, color: '#9ca3af', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#6b7280')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#9ca3af')}
          >
            Politica de Privacidade
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Products;
